module.exports = __webpack_public_path__ + "static/media/cto.2eb1eb08.jpg";